
import { cloneDeep, transform } from 'lodash-es';


export default {
  data() {
    return {
      activeTab: '',
      sectionCatelog: {
        groups: [{
          prefix: '',
          title: '',
          items: []
        }]
      },
      sectionsLoading: false
    }
  },
  watch: {
    activeTab(val) {
      this.handleTabChange(val);
    }
  },
  async mounted() {
    this.sectionCatelog.groups = await this.getSectionGroups();
    this.activeTab = this.sectionCatelog.groups[0].prefix;
  },
  methods: {
    handleOpen() {
      this.$store.commit('editor/disableHover');
    },
    handleClose() {
      this.$store.commit('editor/enableHover');
    },
    async getSectionGroups() {
      const { default: siteSections } = await import('~/sections');
      return siteSections.groups;
    },
    async getSectionItems(prefix) {
      const sectionPrefix = 'SiteSection';
      const componentList = this.$root.$options.components;
      const componentKeyList = [];

      // 获取所有模块组件的key，不包括Lazy开头的
      for (let componentKey in componentList) {
        if(componentKey.startsWith(sectionPrefix)) {
          componentKeyList.push(componentKey);
        }
      }

      const items = [];
      const itemKeys = componentKeyList.filter(key => key.startsWith(sectionPrefix + prefix));

      for (const key of itemKeys) {
        const component = componentList[key];
        let options = component.options;
        
        // 如果是异步组件就等待组件加载，获取组件选项
        if (!component.cid && typeof component == 'function') {
          options = await component();
        }
        const sectionOption = options?.section;
        if (sectionOption) {
          sectionOption.component = key;
          items.push(sectionOption);
        }
      }

      return items;
    },
    async handleTabChange(prefix) {
      this.sectionsLoading = true;
      const items = await this.getSectionItems(prefix);
      const group = this.sectionCatelog.groups.find(group => group.prefix == prefix);
      this.$set(group, 'items', items);

      this.sectionsLoading = false;
    },
    handleSectionMounted(prefix, component) {
      this.$nextTick(() => {
        setTimeout(() => {
          const jrSection = this.$refs[`jrSections${prefix}${component}`][0];
          const section = jrSection.section;
          const sectionElm = jrSection.$el;

          if(!section.data) {
            section.data = {};
          }

          const editableList = sectionElm.querySelectorAll('[data-jr-editable]');
          editableList.forEach(editable => {
            const bind = editable.dataset.jrBind;
            const defaultVal = editable.dataset.jrDefault;
            if (!section.data[bind]) {
              section.data[bind] = JSON.parse(defaultVal);
            }
          });

          const group = this.sectionCatelog.groups.find(group => group.prefix == prefix);
          const sectionIndex = group.items.findIndex(item => item.component == component);
          this.$set(group.items, sectionIndex, cloneDeep(section));

          this.$nextTick(() => {
            document.querySelectorAll('.swiper, .swiper-container').forEach(item => {
              item.swiper && item.swiper.update && item.swiper.update(true);
            })
          })
        }, 0)
      })
    },
    async addSection(section) {
      const sectionId = await this.$store.dispatch('page/addSection', { section, index: this.$store.state.editor.addSection.index });
      this.$nextTick(() => {
        setTimeout(() => {
          document.querySelectorAll('.swiper, .swiper-container').forEach(item => {
            item.swiper && item.swiper.update && item.swiper.update(true);
          })
        }, 0);
      });
    },
  }
}
